import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import CustomInput from "../../components/CustomInput/CustomInput";
import Button from "@material-ui/core/Button";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";

import { login } from "../../actions/admin_action";

import loginPageStyle from "../../assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import { hist } from "../../index";

import { LOGIN_ERROR } from "../../actions/admin_action_types";
import toastr from "toastr";

toastr.options = {
  closeButton: true,
};

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: {
        email: "",
        password: "",
      },
      cardAnimaton: "cardHidden",
    };
  }

  componentDidMount() {
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  changeData = (event) => {
    let { id, value } = event.target;
    let { userInfo } = this.state;
    this.setState({
      userInfo: {
        ...userInfo,
        [id]: value,
      },
    });
  };

  blurData = (event) => {
    let { id, value } = event.target;
    let { userInfo } = this.state;
    this.setState({
      userInfo: {
        ...userInfo,
        [id]: value.trim(),
      },
    });
  };

  _handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.login();
    }
  };

  login = () => {
    let { userInfo } = this.state;
    let { email, password } = userInfo;
    for (let key in userInfo) {
      if (userInfo[key] === "") {
        if (
          key === "password" &&
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
        ) {
          toastr.error(`Valid Email is required!`);
          return true;
        }
        toastr.error(
          `${key.charAt(0).toUpperCase() + key.slice(1)} is required!`
        );
        return true;
      }
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      toastr.error(`Valid Email is required!`);
      return true;
    }
    let obj = {
      email: email.toLowerCase(),
      password,
    };
    this.props.login(obj);
  };

  goToForgotPass = () => {
    hist.push("/admin/pages/forgetpassword");
  };

  componentWillReceiveProps = (nextProps) => {
    let { error } = nextProps;
    if (error) {
      this.setState({
        error,
      });
    }
    this.props.removeError();
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form>
              <Card login className={classes[this.state.cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter} loginhead`}
                  color="primary"
                >
                  <h4 className={classes.cardTitle}>Log In</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="Email..."
                    id="email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    type="text"
                    onChange={this.changeData}
                    onBlur={this.blurData}
                    required={true}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Email className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <CustomInput
                    labelText="Password"
                    id="password"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    type="password"
                    onChange={this.changeData}
                    required={true}
                    onKeyPress={this._handleKeyPress}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>
                            lock_outline
                          </Icon>
                        </InputAdornment>
                      ),
                    }}
                  />
                </CardBody>
                <div style={{ textAlign: "center", margin: "10px" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    className="loginbtn"
                    onClick={this.login}
                    style={{ width: "52%" }}
                  >
                    Login
                  </Button>
                </div>
                {/* <div style={{ textAlign: "center", margin: "10px" }}>
                  <Button
                    color="primary"
                    onClick={this.goToForgotPass}
                    style={{ width: "52%", color: "#242b40" }}
                  >
                    Forgot Password ?
                  </Button>
                </div> */}
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    // loginError: state.admin.loginError
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    removeError: () =>
      dispatch({
        type: LOGIN_ERROR,
        payload: null,
      }),
    login: (data) => dispatch(login(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(loginPageStyle)(LoginPage));
